var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountDarkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11221",
    "data-name": "Group 11221",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.826,
    height: 25.398,
    viewBox: "0 0 22.826 25.398",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4119",
    "data-name": "Rectangle 4119",
    width: 22.826,
    height: 25.398,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11220",
    "data-name": "Group 11220",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1350",
    "data-name": "Path 1350",
    d: "M11.414,193.578h-8.5a2.782,2.782,0,0,1-2.074-.8,2.593,2.593,0,0,1-.677-2.826,11.663,11.663,0,0,1,4.064-5.626A10.628,10.628,0,0,1,6.714,182.9a12.769,12.769,0,0,1,3.7-.9,11.764,11.764,0,0,1,6.815,1.443,11.886,11.886,0,0,1,2.926,2.311,11.432,11.432,0,0,1,2.521,4.291,2.572,2.572,0,0,1-.572,2.635,2.51,2.51,0,0,1-1.783.873c-.259.021-.519.027-.779.028q-4.065,0-8.13,0m.014-1.812q4.2,0,8.4,0a2.868,2.868,0,0,0,.409-.03.87.87,0,0,0,.714-1.113,8.879,8.879,0,0,0-1.524-2.924,9.748,9.748,0,0,0-2.028-1.972,11.647,11.647,0,0,0-1.6-.969,10.031,10.031,0,0,0-3.355-.925,10.207,10.207,0,0,0-3.283.186,9.743,9.743,0,0,0-2.9,1.152,10.307,10.307,0,0,0-2.421,2,9.525,9.525,0,0,0-1.977,3.455.893.893,0,0,0,.72,1.113,3.5,3.5,0,0,0,.452.03q4.193,0,8.387,0",
    transform: "translate(0 -168.18)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1351",
    "data-name": "Path 1351",
    d: "M66.938,6.3A6.313,6.313,0,0,1,73.2,0,6.224,6.224,0,0,1,79.61,6.082a6.3,6.3,0,0,1-6.3,6.592A6.4,6.4,0,0,1,66.938,6.3m6.439,4.58A4.605,4.605,0,0,0,77.843,6.32a4.574,4.574,0,0,0-4.625-4.536,4.548,4.548,0,1,0,.16,9.094",
    transform: "translate(-61.872 0)",
    fill: "#0094d1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountDarkIcon);
export default __webpack_public_path__ + "static/media/account-dark-icon.c2e32ab6e417b79ae106a996823f07c5.svg";
export { ForwardRef as ReactComponent };